import api from '../../api'
import Logger from '../../utility/loggerUtil'

export default {
  async getCollateralPrices (context) {
    try {
      const vehicleEstimate = await api.applicationVehicleInfo.getCollateralPrices(
        Number.parseInt(context.rootState.applicationCustomer.applicationId),
        context.state.year,
        context.state.make,
        context.state.model,
        context.state.series,
        context.state.style,
        context.state.vehicleMileage,
        context.rootState.applicationCustomer.state
      )

      return vehicleEstimate
    } catch (error) {
      Logger.error('Error on applicationVehicle/getCollateralPrices')
      Logger.debug(error)
      throw error
    }
  },

  async updateApplicationVehicle (context, data) {
    try {
      await api.applicationVehicleInfo.update(
        data.applicationId,
        data.userIsTitleHolder,
        data.state,
        data.titleAddress,
        data.customerEstimate,
        data.estimatePercent,
        data.year,
        data.make,
        data.model,
        data.series,
        data.style,
        data.vehicleMileage,
        data.lienHolderName,
        data.lienHolderPhone,
        data.lienHolderAccountNumber,
        data.estimatedPayoffAmount,
        data.vehicleEstimate?.condition,
        data.registrationCounty
      )

      context.commit('updateVehicleInformation', {
        userIsTitleHolder: data.userIsTitleHolder,
        state: data.state,
        titleAddress: data.titleAddress,
        customerEstimate: data.customerEstimate,
        estimatePercent: data.estimatePercent,
        description: data.description,
        year: data.year,
        make: data.make,
        model: data.model,
        series: data.series,
        style: data.style,
        vehicleMileage: data.vehicleMileage,
        lienHolderName: data.lienHolderName,
        lienHolderPhone: data.lienHolderPhone,
        lienHolderAccountNumber: data.lienHolderAccountNumber,
        estimatedPayoffAmount: data.estimatedPayoffAmount,
        vehicleEstimate: data.vehicleEstimate,
        registrationCounty: data.registrationCounty
      })
    } catch (error) {
      Logger.error('Error on applicationVehicle/updateApplicationVehicle')
      Logger.debug(error)
      throw error
    }
  },

  async updateVehicleCoOwner (context, data) {
    try {
      // TODO: Get actual property names from ACV
      // SpouseIsCobo is currently an application prop and a borrower prop in ACV
      // Borr[0].SpouseIsCobo
      // CoboOnTitle
      await api.applicationVehicleInfo.updateCoOwner(
        Number.parseInt(context.rootState.applicationCustomer.applicationId),
        data.firstName,
        data.middleName,
        data.lastName,
        data.suffixName,
        data.hasCoOwner
      )

      context.commit('updateVehicleInformation', {
        coOwnerFirstName: data.firstName,
        coOwnerMiddleName: data.middleName,
        coOwnerLastName: data.lastName,
        coOwnerSuffixName: data.suffixName,
        hasCoOwner: data.hasCoOwner
      })
    } catch (error) {
      Logger.error('Error on applicationVehicle/updateVehicleCoOwner')
      Logger.debug(error)
      throw error
    }
  },

  async reset (context) {
    try {
      context.commit('reset')
    } catch (e) {
      Logger.error('Error on applicationVehicle/reset')
      Logger.debug(e)
      throw e
    }
  }
}
